import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  titulo: {
    textAlign: 'center',
    fontSize: '35px',
    margin: "10px 0px",
    fontWeight: 800
  },
  contenedorCoberturas:{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
	},
  contenedorCoberturas_item: {
    width: '18%',
    display: "flex",
    flexDirection: 'column',
    alignItems: 'center',
    margin: "2px 0px",
  },
  contenedorCoberturas_item_fisrt: {
    width: '50%',
  },
  contenedorCoberturas_item_second: {
    width: '32%',
  },
  contenedorCoberturas_item_text: {
    textAlign: 'center',
    margin: "0px 0px 15px 0px",
    fontWeight: 600,
    fontSize: '18px',
    width: '100%',
    textTransform: 'uppercase',
    '@media (max-width:868px)':{
      fontSize: '17px',
    }
  },
  contenedorCoberturas_item_icon: {
        width: 25,
        height: 25,
        marginBottom: 10
    },
    contenedorCoberturas_item_boton: {
      fontSize: 12,
      padding: 5,
      '@media (max-width:868px)':{
          fontSize: 16,
          padding: "5px 10px",
        }
    },
    tituloFormulario: {
      textAlign: 'center',
      fontSize: '27px',
      margin: "5px 0px",
      fontWeight: 800
    },
    subtituloFormulario: {
      textAlign: 'center',
      fontSize: '24px',
      margin: "5px 0px 0px 0px",
      fontWeight: 800
    },
    contenedorButton: {
      display: "flex",
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '20px'
    }
}));